<template>
    <!-- <div> -->
        <mark :class="{'color0': baz.key0 == text,'color1': baz.key1 == text,'color2': baz.key2 == text,'color3': baz.key3 == text,'color4': baz.key4 == text,'color5': baz.key5 == text,'color6': baz.key6 == text}">
            <slot> 
            </slot>
        </mark>
    <!-- </div> -->
</template>
<script>
export default {
    props: ['baz','text'],
    data() {
        return {

        }
    } 
}
</script>
